import React from 'react';
import { PDFDownloadLink, pdf } from '@react-pdf/renderer';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import Document from 'containers/pdfs/specifications';
import { getCodeLetterForPdf } from 'utils/codes';
import { Button, Tooltip } from 'antd';

const DownLoadPDF = ({
  recipeIngredient, detailsSpecification, id, recipe, products
}) => {
  const specificationNumber = id || uuid();
  const { message, codes } = getCodeLetterForPdf(recipeIngredient);
  return (
    <PDFDownloadLink
      document={(
        <Document
          codes={codes}
          details={detailsSpecification}
          message={message}
          id={specificationNumber}
          recipe={recipe}
          products={products}
        />
      )}
      fileName="cahier_des_charges_flexible.pdf"
    >
      {({
      // eslint-disable-next-line no-unused-vars
        blob, url, loading, error
      }) => (
        <Tooltip title="Générer au format pdf">
          <Button type="primary">Obtenir le PDF</Button>
        </Tooltip>
      )}
    </PDFDownloadLink>
  );
};

DownLoadPDF.propTypes = {
  recipeIngredient: PropTypes.shape({}),
  detailsSpecification: PropTypes.shape({}),
  id: PropTypes.string,
  recipe: PropTypes.string,
  products: PropTypes.arrayOf(
    PropTypes.arrayOf({
      r1: PropTypes.shape({
        codes: PropTypes.string,
      }),
      r2: PropTypes.shape({
        codes: PropTypes.string,
      })
    })
  )
};

export default DownLoadPDF;

export const generateBlobPdf = async (recipeIngredient, detailsSpecification, products) => {
  const { message, codes } = getCodeLetterForPdf(recipeIngredient);
  const document = <Document codes={codes} details={detailsSpecification} message={message} products={products} />;
  const Pdf = pdf(document);
  Pdf.updateContainer(<Document codes={codes} details={detailsSpecification} message={message} products={products} />);
  const blob = await Pdf.toBlob();
  // eslint-disable-next-line no-undef
  const file = new File([blob], 'Cahier_des_charge.pdf', { lastModified: (new Date()).getTime() });
  return file;
};
